var imgStorie = document.querySelectorAll('.stories ul li img');
for (var i = 0; i < imgStorie.length; i++) {
  (function(index) {
    imgStorie[index].addEventListener('click', function(event) {
      document.querySelector('.modal-reel-' + (index + 1)).classList.add("active");
      var video = document.querySelector('.modal-reel-' + (index + 1) + ' video');

      video.play();

      const modalReel = document.querySelector('.modal-reel-' + (index + 1));
      modalReel.addEventListener('mousemove', function(event) {
          if (!event.target.closest('video')) {
            if ( document.querySelector('mouse-cursor').classList.contains("active") === false ){
              document.querySelector('mouse-cursor').classList.add("active");
            }
          }else{
            if ( document.querySelector('mouse-cursor').classList.contains("active") === true ){
              document.querySelector('mouse-cursor').classList.remove("active");
            }
          }
      });

      modalReel.onclick = function() {
        if (!event.target.closest('video')) {
          video.pause();
          document.querySelector('.modal-reel-' + (index + 1)).classList.remove("active");
          if ( document.querySelector('mouse-cursor').classList.contains("active") === true ){
            document.querySelector('mouse-cursor').classList.remove("active");
          }
        }
      };

      video.addEventListener('ended', () => {
        document.querySelector('.modal-reel-' + (index + 1)).classList.remove("active");
        if ( document.querySelector('mouse-cursor').classList.contains("active") === true ){
          document.querySelector('mouse-cursor').classList.remove("active");
        }
      });
      
    });
  })(i);
}


function playAudio(audioId) {
  const audios = document.querySelectorAll('audio');

  audios.forEach(audio => {
    if (!audio.paused && audio.id !== audioId) {
      audio.pause();
      audio.parentElement.querySelector('svg[class*="play-extrait"]').style.cssText = "display: block;";
      audio.parentElement.querySelector('svg[class*="pause-extrait"]').style.cssText = "display: none;";
    }
  });

  document.getElementById(audioId).play();
}


if (!!document.querySelector(".product__info .product__rating") === true){
  document.querySelector(".product__info .product__rating").onclick = function() {
    var topReviews = document.querySelector(".shopify-section.app-section:has(.jdgm-carousel-wrapper)").offsetTop;
    window.scrollTo({top: (topReviews - 100),behavior: 'smooth'});
  };
}


document.addEventListener("DOMContentLoaded", function() {
  if (!!document.querySelector(".en-savoir-plus") === true){
    var width_screen = window.innerWidth;
    
    document.querySelector(".en-savoir-plus").onclick = function() {
      if (!!document.querySelector(".second-product_info") === true){
        var element = document.querySelector(".second-product_info");
        if (!element.hasAttribute("open")) {
          element.querySelector(".product__accordion.details .details__summary").click();
        }
        if (width_screen < 1024) {
          var topDesc = element.offsetTop - 40;
        }else{
          var topDesc = element.offsetTop;
        }
      }else{
        var element = document.querySelector("#description-redirection");
        if (!element.hasAttribute("open")) {
          element.querySelector(".product__accordion.details .details__summary").click();
        }
        if (width_screen < 1024) {
          var topDesc = element.offsetTop + 300;
        }else{
          var topDesc = element.offsetTop + 10;
        }
      }
      window.scrollTo({top: (topDesc + 60),behavior: 'smooth'});
    };
  }
});

document.addEventListener('DOMContentLoaded', function() {
  customElements.whenDefined('scroll-shadow').then(() => {
    const scrollShadow = document.querySelector('scroll-shadow');
    
    // Supprimer seulement le template qui contient les flèches
    const template = scrollShadow.querySelector('template');
    if (template) {
      template.remove();
    }

    // Alternative : vider le shadow-root tout en gardant la structure
    if (scrollShadow.shadowRoot) {
      const slot = document.createElement('slot');
      scrollShadow.shadowRoot.innerHTML = '';
      scrollShadow.shadowRoot.appendChild(slot);
    }
  });
});





